export default {
    csManagement: {
        page: {
            title: 'CS Management',
            description: 'Manage tenant quotas, document limits and token consumption',
        },
        quota: {
            searchPlaceholder: 'Search tenant ID',
            typePlaceholder: 'Quota type',
            search: 'Search',
            create: 'Add Quota',
            tenantId: 'Tenant ID',
            quotaType: 'Quota Type',
            typeDocument: 'Document',
            typeToken: 'Token',
            quotaLimit: 'Limit',
            quotaUsed: 'Used',
            contractPeriod: 'Contract Period',
            contractStart: 'Start Date',
            contractEnd: 'End Date',
            status: 'Status',
            statusActive: 'Active',
            statusExpired: 'Expired',
            remark: 'Remark',
            action: 'Action',
            edit: 'Edit',
            delete: 'Delete',
            createTitle: 'Add Quota',
            editTitle: 'Edit Quota',
            cancel: 'Cancel',
            confirm: 'Confirm',
            saving: 'Saving...',
            featureConfig: 'Feature Config',
            featureConfigTitle: 'Feature Permission Config',
            featureQuotaSectionTitle: 'Feature Quota Limits',
            featureQuotaSectionDesc: 'Set how many documents each feature can create during the contract period. -1 means unlimited, 0 disables the feature.',
            featureDisclosure: 'Disclosure',
            featureDisclosureLimit: 'Disclosure Limit',
            featureDisclosureDesc: 'Patent disclosure drafting',
            featurePatentDraft: 'Patent Application',
            featurePatentDraftLimit: 'Patent Application Limit',
            featurePatentDraftDesc: 'Patent application drafting',
            featureProsecution: 'OAR Response',
            featureProsecutionLimit: 'OAR Response Limit',
            featureProsecutionDesc: 'Office action response drafting',
            featureLimitHint: '* -1 means unlimited, 0 disables the feature',
            featureLimitExceeded: 'Feature quota total {total} cannot exceed quota limit {limit}',
            featureUsed: 'Used',
            featureRemaining: 'Remaining',
            featureReachedLimit: 'Limit reached',
            featureLimitBelowUsedWarning: 'Limit is below used count',
            featureDisabled: 'Disabled',
            userQuotaTitle: 'User Quota Details',
            userQuotaHint: 'Company quota limit: {limit}',
            userEmail: 'User Email',
            unlimited: 'Unlimited',
            addUser: 'Add User',
            addUserPlaceholder: 'Enter user email',
            reset: 'Clear',
            deleteUserQuotaConfirmTitle: 'Delete this user quota configuration?',
            deleteUserQuotaConfirmDesc: 'After deletion, this user will no longer appear in user quota details and personal feature limits will return to unconfigured.',
            tenantName: 'Company Name',
            configuredMembers: 'Configured Members',
            noConfiguredMembers: 'No configured members for this company',
            tenantInfoNotFound: 'Company not found',
            tenantInfoFailed: 'Failed to fetch, please retry',
            featureList: 'Features',
            featureAll: 'All',
        },
    },
};
